import { Box } from "@mantine/core";
import {
  ArticleText,
  TitleSmall,
  NumberedText,
  NumberText,
  ReferenceItem,
  ReferenceLink,
} from "./utils";
import type {
  ContentBlock,
  ContentNumbered,
  ContentParagraph,
  ContentReferences,
  ContentTitle,
} from "../../types/blogTypes";

export function renderContentBlock(block: ContentBlock, index: number) {
  switch (block.type) {
    case "title":
      return <TitleSmall key={index}>{(block as ContentTitle).text}</TitleSmall>;

    case "paragraph":
      return <ArticleText key={index}>{(block as ContentParagraph).text}</ArticleText>;

    case "numbered": {
      const numbered = block as ContentNumbered;
      return (
        <Box key={index}>
          {numbered.items.map((item, itemIndex) => (
            <Box key={itemIndex} mb="md">
              {item.title ? (
                <NumberText>
                  {item.number}. {item.title}
                </NumberText>
              ) : (
                <NumberText>{item.number}.</NumberText>
              )}
              <NumberedText>{item.text}</NumberedText>
            </Box>
          ))}
        </Box>
      );
    }

    case "references": {
      const refs = block as ContentReferences;
      return (
        <Box key={index}>
          <TitleSmall>References</TitleSmall>
          {refs.items.map((ref, refIndex) => (
            <ReferenceItem key={refIndex} number={ref.number}>
              {ref.text}
              {ref.link && (
                <>
                  <br />
                  <ReferenceLink href={ref.link}>{ref.link}</ReferenceLink>
                </>
              )}
            </ReferenceItem>
          ))}
        </Box>
      );
    }

    default:
      return null;
  }
}
